import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import type { UseCaseId } from '../types'
import HomeContent from '../../../../src/components/SectionContent'

const TABS = [
  { label: 'Overview', value: 'overview' },
  { label: 'Learning pathway', value: 'learning-pathway' },
  { label: 'Data needs', value: 'data-needs' },
] as const

function UseCaseTabNav() {
  const navigate = useNavigate()
  const { useCaseId } = useParams<{ useCaseId: UseCaseId }>()
  const { pathname } = useLocation()

  const activeTab = TABS.find((tab) => pathname.endsWith(tab.value))?.value ?? 'overview'

  return (
    <Tabs value={activeTab} className="w-full">
      <HomeContent className="py-5">
        <TabsList className="h-10">
          {TABS.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              onClick={() => navigate(`/app/home/use-cases/${useCaseId}/${tab.value}`)}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </HomeContent>
    </Tabs>
  )
}

export default UseCaseTabNav
